import type { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";
import type { Database } from "@/integrations/supabase/types";

type SaveUserDataFunction = Database["public"]["Functions"]["save_user_data"];

/**
 * Supabase's generated types do not encode nullable PostgreSQL function
 * parameters, so regeneration types `p_attribute_value` as `string` even
 * though `data.save_user_data` accepts NULL. Keep that durable RPC override
 * outside the generated file and preserve full typing without `any`.
 */
type BuildingDataDatabase = Omit<Database, "public"> & {
  public: Omit<Database["public"], "Functions"> & {
    Functions: Omit<Database["public"]["Functions"], "save_user_data"> & {
      save_user_data: Omit<SaveUserDataFunction, "Args"> & {
        Args: Omit<SaveUserDataFunction["Args"], "p_attribute_value"> & {
          p_attribute_value: string | null;
        };
      };
    };
  };
};

export const buildingDataRpcClient = supabase as unknown as SupabaseClient<BuildingDataDatabase>;
